module.exports = __webpack_public_path__ + "static/media/SK.6adb8e91.png";